Ext.define('ViewSkpPomiary', {
    extend: 'Ext.panel.Panel',
    grid: null,
    gridpage: null,
    id: "skppomiary",
    rebuildGrid: false,
    showState: false,
    statics: {
        accessPropertyViewName: "access.view.skpspomiary"
    },
    cat: "p",
    text: Lang.pomiary_zbiornika,
    buttonIconCls: "iconSkpPomiary",
    layout: 'border',
    frame: false,
    border: false,
    initComponent: function () {
        this.buttonId = "main-view-button-" + this.id;
        this.buildGrid();
        this.items = [{
            region: "north",
            xtype: 'toolbar',
            items: [{
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconPDF",
                text: Lang.pdf.capitalise(),
                scope: this,
                handler: this.getDownloadLsPdf
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEXCEL",
                text: Lang.excel.capitalise(),
                scope: this,
                handler: this.getDownloadLsExcel
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconRefresh",
                text: Lang.odswiez.capitalise(),
                scope: this,
                handler: this.refreshDatastore
            }, {
                xtype: "box",
                id: this.id + "kontekstfirmybox",
                cls: "kontekstfirmy-box"
            }, {
                id: this.id + "kontekstfirmy",
                xtype: 'label',
                style: 'display:block;margin-right:5px',
                cls: "kontekstfirmy-text"
            }]
        }, {
            region: "center",
            xtype: 'panel',
            frame: false,
            border: false,
            layout: 'fit',
            items: [this.grid]
        }];
        this.callParent(arguments);
    },
    showFirst: function (eventMain) {
        eventMain.on("firmaChangeContext", this.changeContext, this);
    },
    remove: function () {
        this.callParent(arguments);
    },
    show: function () {
        this.showState = true;
        this.callParent(arguments);
        this.changeContextRebuild(null, null);
        if (this.grid && this.grid.rendered)
            this.grid.getDockedComponent(1).updatePageSize(getNumberOfVisibleRows(this.grid));
        this.refreshDatastore();
    },
    hide: function () {
        this.showState = false;
        this.callParent(arguments);
    },
    changeContextRebuild: function (eAppFIRMACTX, eAppFIRMACTXold) {
        var kontekstfirmy = Ext.getCmp(this.id + "kontekstfirmy");
        var kontekstfirmybox = Ext.getCmp(this.id + "kontekstfirmybox");
        if (AppFIRMACTX != null && !Const.AGGREGATEDCORE) {
            kontekstfirmybox.update("<div class='appSetColourRedSplit'></div>");
            kontekstfirmy.setText(Lang.pracujesz_w_kontekscie + AppFIRMACTX.nazwa);
        } else {
            kontekstfirmybox.update("");
            kontekstfirmy.setText("");
        }
        if (this.rebuildGrid) {
            this.rebuildGrid = false;
            var onwer = this.grid.ownerCt;
            Ext.suspendLayouts();
            onwer.remove(this.grid);
            this.grid.destroy();
            this.buildGrid();
            onwer.add(this.grid);
            Ext.resumeLayouts(true);
            if (this.grid && this.grid.rendered)
                this.grid.getDockedComponent(1).updatePageSize(getNumberOfVisibleRows(this.grid));
        }
    },
    changeContext: function (eAppFIRMACTX, eAppFIRMACTXold) {
        this.rebuildGrid = true;
        if (this.showState) {
            this.changeContextRebuild(null, null);
            this.refreshDatastore();
        }
    },
    buildGrid: function (datals) {
        var store = Ext.create('Ext.data.Store', {
            autoLoad: false,
            remoteSort: true,
            remoteFilter: true,
            pageSize: 50,
            fields: [{
                name: 'czas',
                mapping: 'czas',
                type: 'date'
            }, {
                name: 'skp',
                mapping: 'skp'
            }, {
                name: 'sterownik',
                mapping: 'sterownik'
            }, {
                name: 'plyn',
                mapping: 'plyn'
            }, {
                name: 'zbiornik',
                mapping: 'zbiornik'
            }, {
                name: 'addinfo',
                mapping: 'addinfo'
            }, {
                name: 'lastpomiar',
                mapping: 'lastpomiar'
            }, {
                name: 'lastpomiartemp',
                mapping: 'lastpomiartemp'
            }, {
                name: 'laststateflags',
                mapping: 'laststateflags'
            }, {
                name: 'laststateflagssckpstate',
                mapping: 'laststateflagssckpstate'
            }, {
                name: 'laststateflagststate',
                mapping: 'laststateflagststate'
            }, {
                name: 'laststateflagsskpstate',
                mapping: 'laststateflagsskpstate'
            }, {
                name: 'wartoscprzetwornika',
                mapping: 'wartoscprzetwornika'
            }, {
                name: 'project',
                mapping: 'project'
            }, {
                name: 'stanzbiornikaar',
                mapping: 'stanzbiornikaar'
            }],
            proxy: {
                type: "ajax",
                url: "rest/skppom/getList",
                filterParams: "filters",
                timeout: 60000,
                actionMethods: {
                    read: "POST"
                },
                reader: {
                    type: 'json',
                    id: 'id',
                    rootProperty: 'data',
                    totalProperty: 'total'
                },
                listeners: {
                    scope: this,
                    exception: handlGridLoadExceptionJsonRpcL
                }
            },
            sorters: {
                property: 'czas',
                direction: 'DESC'
            },
            listeners: {
                scope: this,
                load: handlGridLoadStoreCheckJsonRpcL
            }
        });
        var rendererCKPFlags = function (value, meta, record, rowIndex, colIndex, store) {
            var sstyle = "";
            if (record.get("iserror")) {
                sstyle = "color:red";
            }
            return "<span style='" + sstyle + "'>" + value + "</span>";

        };
        var cols = [{
            header: Lang.sterownik,
            flex: 2,
            sortable: true,
            dataIndex: 'sterownik',
            filter: {
                type: 'string'
            },
            filterable: true,
            renderer: function (value, meta, record, rowIndex, colIndex, store) {
                return rendererCKPFlags(value, meta, record, rowIndex, colIndex, store);
            }
        }, {
            header: Lang.plyn,
            flex: 2,
            sortable: true,
            dataIndex: 'plyn',
            filter: {
                type: 'string'
            },
            hidden: false,
            filterable: true,
            renderer: function (value, meta, record, rowIndex, colIndex, store) {
                return rendererCKPFlags(value, meta, record, rowIndex, colIndex, store);
            }
        }, {
            header: Lang.zbiornik,
            flex: 2,
            sortable: true,
            dataIndex: 'zbiornik',
            filter: {
                type: 'string'
            },
            hidden: false,
            filterable: true,
            renderer: function (value, meta, record, rowIndex, colIndex, store) {
                return rendererCKPFlags(value, meta, record, rowIndex, colIndex, store);
            }
        }, {
            header: Lang.skp,
            flex: 2,
            sortable: true,
            dataIndex: 'skp',
            filter: {
                type: 'string'
            },
            hidden: false,
            filterable: true,
            renderer: function (value, meta, record, rowIndex, colIndex, store) {
                return rendererCKPFlags(value, meta, record, rowIndex, colIndex, store);
            }
        }, {
            header: Lang.pomiar_zbiornika,
            flex: 1,
            sortable: true,
            dataIndex: 'lastpomiar',
            renderer: function (value, meta, record, rowIndex, colIndex, store) {
                if (value == null)
                    return null;
                value = Ext.Number.roundToPrecision(value, 3).toString().replace(".", Ext.DECIMAL_SEPARATOR);
                return rendererCKPFlags(value, meta, record, rowIndex, colIndex, store);
            },
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.wartosc_nieskompensowana,
            flex: 1,
            sortable: true,
            dataIndex: 'lastpomiarbezkompensacji',
            renderer: function (value, meta, record, rowIndex, colIndex, store) {
                if (value == null)
                    return null;
                value = Ext.Number.roundToPrecision(value, 3).toString().replace(".", Ext.DECIMAL_SEPARATOR);
                return rendererCKPFlags(value, meta, record, rowIndex, colIndex, store);
            },
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.pomiar_temperatury,
            wflex: 1,
            sortable: true,
            dataIndex: 'lastpomiartemp',
            renderer: function (value, meta, record, rowIndex, colIndex, store) {
                if (value == null)
                    return null;
                value = Ext.Number.roundToPrecision(value, 3).toString().replace(".", Ext.DECIMAL_SEPARATOR);
                return rendererCKPFlags(value, meta, record, rowIndex, colIndex, store);
            },
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.stan_pomiaru,
            flex: 2,
            sortable: true,
            dataIndex: 'stateinfo',
            // filter: {
            //     type: 'string'
            // },
            hidden: false,
            filterable: true,
            renderer: function (value, meta, record, rowIndex, colIndex, store) {
                return rendererCKPFlags(value, meta, record, rowIndex, colIndex, store);
            }
        }, {
            header: Lang.czas,
            flex: 3,
            sortable: true,
            dataIndex: 'czas',
            renderer: Ext.util.Format.dateRenderer(),
            filter: {
                type: 'date'
            },
            filterable: true
        }, {
            header: Lang.projekt,
            flex: 1,
            sortable: true,
            dataIndex: 'project',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.stan_arytmetyczny,
            flex: 2,
            sortable: true,
            dataIndex: 'stanzbiornikaar',
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.wartosc_przetwornika,
            flex: 1,
            sortable: true,
            dataIndex: 'wartoscprzetwornika',
            filter: {
                type: 'numeric'
            },
            filterable: true
        }];
        if (!Const.ENABLEPROJECTS) {
            removeObjectFromArrayById(cols, "project");
        }
        if (!AppOPERATORROLA === Const.OPERATOR_P_SERWIS) {
            removeObjectFromArrayById(cols, "wartoscprzetwornika");
        }
        this.grid = new Ext.ux.grid.GridPanelExd({
            plugins: {
                gridfilters: true
            },
            store: store,
            columns: cols,
            frame: false,
            border: false,
            stateId: "grid-" + this.id + (AppFIRMACTX == null ? "-all" : "-"),
            stateful: true,
            stripeRows: true,
            enableHdMenu: true,
            selModel: {
                selType: 'rowmodel',
                mode: 'single',
                allowDeselect: false
            },
            bbar: {
                xtype: 'pagingtoolbarexd',
                displayInfo: true,
                pagingStore: store
            }
        });
        this.grid.addListener("render", function () {
        });
        this.grid.store.addListener("load", function () {
            updateCzasRefreshSerwer();
        });
        this.grid.addListener("rowcontextmenu", function (grid, rowi, e) {
            e.preventDefault();
        });
        this.grid.addListener("containercontextmenu", function (grid, e) {
            e.preventDefault();
        });
    },
    getDownloadLsPdf: function () {
        var defd = this.grid.getDefGridQueryCSF();
        postFormAsync("rest/skppom/downloadExportPdfOtherList", {
            format: "pdf",
            name: Lang.pomiary_zbiornika,
            filters: defd.filters,
            sort: defd.sorters,
            defd: Ext.encode(defd)
        }, null);
    },
    getDownloadLsExcel: function () {
        var defd = this.grid.getDefGridQueryCSF();
        postFormAsync("rest/skppom/downloadExportPdfOtherList", {
            format: "excel",
            name: Lang.pomiary_zbiornika,
            filters: defd.filters,
            sort: defd.sorters,
            defd: Ext.encode(defd)
        }, null);
    },
    refreshDatastore: function () {
        this.grid.store.load();
    }
});
